module.exports = __webpack_public_path__ + "static/media/example-3.f8a52fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Millard/example-3.jpg
// module id = 271
// module chunks = 0